// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__wiRuh","messages":"Chat_messages__3iwOH","dateDivider":"Chat_dateDivider__29ht2"};